module.exports = __webpack_public_path__ + "img/saum_gelb_candy.79ef57b7.jpg";